export default __webpack_public_path__ + "static/media/no-fees.0f60d297.svg";